import { GetBookingStepQuery } from 'generated/graphql';
import { isAmKey } from '../../view-model/amProfiles';
import { BookingStep } from './BookCall.types';

type GQLBookingStep = GetBookingStepQuery['GetBookingStep'];

export const toBookingStep = (raw: GQLBookingStep): BookingStep => ({
  qualified: raw.qualified,
  amKey: isAmKey(raw.amKey) ? raw.amKey : null,
  amDisplayName: raw.amDisplayName ?? null,
  meetingUrl: raw.meetingUrl ?? null,
  prefillEmail: raw.prefillEmail ?? null,
  prefillFirstName: raw.prefillFirstName ?? null,
});
